import axios from 'axios';

// 清除 URL 中的 code（避免暴露授权码）
// 用 history.replaceState 而非 location.replace，避免整个页面刷新
// 否则页面会重新挂载 Vue 应用，导致 /signnew/ 被重复请求
const cleanAuthUrl = () => {
  const cleanUrl = window.location.origin + window.location.pathname + window.location.hash;
  window.history.replaceState({}, '', cleanUrl);
};

// getmyname 请求去重标记（sessionStorage + 时间戳）
// 防止短时间内重复带 code 进入页面时重复请求后端；
// 30 秒视为“仍在进行中”，超过则认为是残留标记，允许重新请求。
const NAME_REQ_TS_KEY = 'getmyname_req_ts';
const NAME_REQ_WINDOW_MS = 30 * 1000;

(function extractCodeFromUrl() {
  const url = new URL(window.location.href);
  const authCode = url.searchParams.get('code');

  if (authCode) {
    localStorage.setItem('oauth_code', authCode);
    console.log('已保存 code 到 localStorage:', authCode);

    const existingUsername = localStorage.getItem('comUsername');
    if (
      !existingUsername ||
      existingUsername.trim() === '' ||
      existingUsername.startsWith('errmsg')
    ) {
      // 已有进行中的请求（30 秒内），直接跳过，避免重复请求后端
      const reqTs = parseInt(sessionStorage.getItem(NAME_REQ_TS_KEY) || '0', 10);
      if (reqTs && Date.now() - reqTs < NAME_REQ_WINDOW_MS) {
        console.log('getmyname 请求已在进行中，跳过重复请求');
        cleanAuthUrl();
        return;
      }

      // 发起请求，并在完成后跳转
      sessionStorage.setItem(NAME_REQ_TS_KEY, String(Date.now()));
      axios.get('https://xzs.lbzuche.cn/getmyname', { params: { action: 'get', authCode } })
        .then(response => {
          console.log('get getmyname:', authCode);
          if (response.data) {
            console.log('getmyname:', response.data);
            localStorage.setItem('comUsername', response.data);
            localStorage.setItem('authCompleted', 'true');
          }
        })
        .catch(err => {
          console.error('后端错误:', err);
        })
        .finally(() => {
          sessionStorage.removeItem(NAME_REQ_TS_KEY);
          cleanAuthUrl();
        });
    } else {
      localStorage.setItem('authCompleted', 'true');
      console.log('comUsername 已存在，跳过请求:', existingUsername);
      cleanAuthUrl();
    }
  } else {
    console.log('当前页面已是干净URL，无需跳转处理');
  }
})();




import { createApp } from 'vue'
import App from './App.vue'


createApp(App).mount('#app')
